import type { Tour } from '../../types';

export const searchTour: Tour = {
  id: 'institution-search',
  name: 'Search & Reports Tour',
  description: 'Learn how to find documents and generate reports',
  category: 'institution',
  showProgress: true,
  requiredPath: '/search',
  steps: [
    {
      id: 'search-1',
      target: 'search-header',
      title: 'Advanced Search',
      content: 'Find any document instantly with powerful search capabilities. Search by title, content, metadata, or custom fields.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'search-2',
      target: 'search-input',
      title: 'Search Bar',
      content: 'Enter keywords, document titles, or reference numbers. The search is instant and shows results as you type.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'search-3',
      target: 'search-filters',
      title: 'Filter Options',
      content: 'Narrow down results by date range, document type, classification, status, or department.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'search-4',
      target: 'search-results',
      title: 'Search Results',
      content: 'Results are ranked by relevance. Each result shows a preview and highlights matching text.',
      position: 'top',
      spotlight: true,
    },
    {
      id: 'search-5',
      target: 'search-save-btn',
      title: 'Save Searches',
      content: 'Save frequently used search queries for quick access later. Saved searches appear in your sidebar.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'search-6',
      target: 'search-export-btn',
      title: 'Export Results',
      content: 'Export search results to Excel or PDF for reporting. Choose which columns to include in your export.',
      position: 'left',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
